import { Goerli } from "@usedapp/core";


// export const ROUTER_ADDRESS = "0xcA817F4a455ef57c16ccC675E2Be82fc370b42c5"; //ito yong transaction hash sa cranq sa final run, dapat naka .env to //FOR BUDOL COIN
export const ROUTER_ADDRESS = process.env.REACT_APP_ROUTER_ADDRESS; 
export const DAPP_CONFIG = {
  readOnlyChainId: Goerli.chainId,
  readOnlyUrls: {
    // [Goerli.chainId]: "https://eth-goerli.g.alchemy.com/v2/UNy-XVeToVhxcqFkMXlORH7IaeMvSOB2", //provided url sa cranq / alchemy.com provided, dapat naka .env to //FOR BUDOL COIN.
    [Goerli.chainId]: process.env.REACT_APP_GOERLIALCHEMY,
  },
};




